import { t } from '@/locales/translate';

/**
 * Временный пропуск машин в очереди.
 *
 * Жило в разделе автомоек, но нужно и в пользователях, и на панели, поэтому
 * переехало сюда, когда раздел снесли. От очереди здесь только это состояние —
 * ни типов мойки, ни её хранилищ.
 */

export interface QueueSkipState {
  skipActive?: boolean;
  skipUntil?: string | null;
  skipDurationMinutes?: number | null;
  skipUsed?: boolean;
}

export function isSkipActive(entry: Pick<QueueSkipState, 'skipActive'>): boolean {
  return entry.skipActive === true;
}

export function formatSkipUntilTime(iso: string): string {
  return new Intl.DateTimeFormat('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(iso));
}

export function getSkipUntilLabel(skipUntil: string | null | undefined): string | null {
  if (!skipUntil) return null;
  return t('common.skip.until', { time: formatSkipUntilTime(skipUntil) });
}
